import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * 폼 컨트롤 프리미티브 (Input · Textarea · Select).
 * Tailwind 토큰 클래스만 사용 → 7개 테마에 자동 반응.
 */

const controlBase =
  'flex w-full rounded-md border border-input bg-background text-sm text-foreground ' +
  'ring-offset-background placeholder:text-muted-foreground ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 ' +
  'disabled:cursor-not-allowed disabled:opacity-50 transition-colors';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={cn(controlBase, 'h-9 px-3 py-1', className)} {...props} />
  ),
);
Input.displayName = 'Input';

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea ref={ref} className={cn(controlBase, 'min-h-[60px] px-3 py-2 resize-y', className)} {...props} />
  ),
);
Textarea.displayName = 'Textarea';

export const Select = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => (
    <select ref={ref} className={cn(controlBase, 'h-9 px-2.5 py-1 cursor-pointer', className)} {...props} />
  ),
);
Select.displayName = 'Select';
